<template>
    <div class="announcement">
        <div class="top-wrapper">
            <div class="title-wrapper">
                <span class="title">{{ $t('word.announcement') }}</span>
                <span>{{ $t('word.total') }} {{ totalCount }} {{ $t('word.item') }}</span>
            </div>
        </div>
        <div class="content-wrapper">
            <div class="announcement-list" v-loading.body="pageLoading">
                <div class="announcement" v-for="announcement in announcementList">
                    <div class="announcement-title-wrapper">
                        <span class="title" :class="{'active': isValid(announcement.invalidTime) }">{{ announcement.title }}</span>
                        <span class="date">{{ formatDate(announcement.createTime) }} ~ {{ formatDate(announcement.invalidTime) }}</span>
                    </div>
                    <p>
                        {{ announcement.content }}
                    </p>
                </div>
            </div>
        </div>
        <div class="center-tasks-pagination" v-if="totalPage>=2">
            <el-pagination @current-change="getAnnouncementList" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import moment from 'moment';
    export default {
        components: {
          axios,
          moment
        },
        data() {
            return {
              pageLoading: false,
              announcementList:[],
              pageIndex: 0,
              totalPage: 0,
              totalCount: 0
            }
        },
        methods: {
          getAnnouncementList(pageIndex) {
            let type = 'anchor';
            if(location.pathname.startsWith('/c/copyrighter')) {
              type = 'author'
            }
            const that = this;
            this.pageLoading = true;
            axios.get(`/api/notice/list/${pageIndex}?type=${type}`).then(res => {
              if (res.data.code === 200) {
                that.announcementList = res.data.data.items;
                that.totalPage = res.data.data.pages;
                that.totalCount = res.data.data.total;
              }
              that.pageLoading = false;
            });

          },
          formatDate(data) {
            return moment(data).format('YYYY-MM-DD');
          },
          isValid(data) {
            return data > (new Date());
          }
        },
        computed: {
        },
        beforeMount() {
          this.getAnnouncementList(1)
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../sass/components/announcement.scss";
    @import "../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// Announcement.vue?224fc85e